import React from 'react';

import styles from './styles.module.scss';

const NoOrders = () => (
  <div className={styles.noOrders}>
    <i className="fal fa-box-open" />
    <h2>No Orders Placed Yet</h2>
    <p>Treat yourself and start shopping!</p>
  </div>
)

export default NoOrders;
